<template>
    <v-card class="subject-item mb-4">
        <v-card-title class="pa-4">
            <v-icon v-if="course.estadoMateria"
                class="notranslate pl-3 pr-6 mdi mdi-check-circle theme--light green--text"
                :class="{'visibility-hidden': !course.inscripto}"
            >mdi-check-circle</v-icon>
            <div class="d-flex flex-column">
                <h5 class="body-1 primary--text mb-1 text-uppercase">{{ course.description || course.descripcion}}</h5>
                <small v-if="course.term" class="caption text">
                    {{ `Desde el ${getFormattedDatePart(course.term?.classStartDate, 'DD/MM')} hasta el ${getFormattedDatePart(course.term?.classEndDate, 'DD/MM')}` }}
                </small>
                <h6 class="text-caption font-small bg-grey-lighten-3 ">{{ $t('modules.portalalumno.academic_charge.subjects.course_dropdown') }}</h6>
            </div>
            <v-spacer></v-spacer>
            <v-btn v-if="reinscription"
                icon
                @click="toggleExpansion"
            >
                <v-icon>
                    {{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                </v-icon>
            </v-btn>
        </v-card-title>

        <v-card-text v-if="isExpanded" class="pa-4">
            <h6 class="caption mb-4">{{ $t('modules.portalalumno.academic_charge.subjects.courses_change') }}</h6>
            <div class="periods-list">
                <div
                    v-for="term in termsAvailable"
                    :key="term.id"
                    class="period-item mb-3"
                    @click="requestConfirmation(term)"
                >
                    <h5 class="body-1 primary--text mb-1 text-uppercase">{{ `${term.description} (${term.code})` }}</h5>
                    <h6 class="caption text">
                        {{ `Desde el ${getFormattedDatePart(term?.classStartDate, 'DD/MM')} hasta el ${getFormattedDatePart(term?.classEndDate, 'DD/MM')}` }}
                    </h6>
                </div>
            </div>


        </v-card-text>
    </v-card>
</template>

<script>
import { $course } from '../Services'

export default {
    name: 'CourseItem',
    props: {
        course: {
            type: Object,
            required: true
        },
        terms: {
            type: Array,
            required: true
        },
        studentCareerId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isExpanded: false,
            termsAvailable: [],
            selectedTerm: null,
            reinscription: true
        }
    },
    mounted() {
        this.filteredTerms();
        this.validateReinscription();
    },
    methods: {
        validateReinscription() {
            const currentDate = new Date();
            const courseStartDate = new Date(this.course.term?.classStartDate);
            if(this.course.term){
                if (currentDate < courseStartDate) {
                    this.reinscription = true
                } else {
                    this.reinscription = false
                }
            }else{
                this.reinscription = true
            }
        },
        filteredTerms() {
            if(this.course.term){
                const filtered = this.terms
                .filter(term => term.id !== this.course.term.id)
                .sort((a, b) => new Date(a.classStartDate) - new Date(b.classStartDate));
            
                this.termsAvailable = filtered;
            }else{
                this.termsAvailable = this.terms;
            }
        },
        toggleExpansion() {
            this.isExpanded = !this.isExpanded;
        },
        requestConfirmation(term) {
            this.$store.dispatch('commons/openPopUp', {
                title: this.$t('modules.portalalumno.academic_charge.subjects.courses_change_title', {
                    DD: this.getFormattedDatePart(term.classStartDate, 'DD'),
                    MM: this.getFormattedDatePart(term.classStartDate, 'MM')
                }),
                content: null,
                actionPrimary: { text: this.$t('actions.confirm'), callback: () => { this.course.estadoMateria ? this.updateCourse(term) : this.inscriptionCourse(term) }},
                actionSecondary: { text: this.$t('actions.cancel'), callback () { } },
                icon: { color: 'warning', name: 'mdi-alert' },
                color: 'primary'
            });
        },
        async updateCourse(term) {
            try {
                await $course.update('inscription', null, {
                    params: {
                        studentCareerId: this.studentCareerId,
                        subjectId: this.course.id,
                        termId: term.id
                    }
                })
                this.$emit('update-course')
            } catch {
                this.$store.dispatch('commons/openPopUp', {
                    title: this.$t('alert'),
                    content: [{ value: this.$t('modules.portalalumno.academic_charge.subjects.courses_change_error') }],
                    actionPrimary: { text: this.$t('actions.accept'), callback () { } },
                    icon: { color: 'error', name: 'mdi-close' },
                    color: 'primary',
                })
            }
        },
        async inscriptionCourse(term) {
            try {
                await $course.create({studentCareerId: this.studentCareerId, courseId: this.course.courseId, termId: term.id}, null , 'inscriptionBody' )
                this.$emit('update-course')
            } catch {
                this.$store.dispatch('commons/openPopUp', {
                    title: this.$t('alert'),
                    content: [{ value: this.$t('modules.portalalumno.academic_charge.subjects.courses_change_error') }],
                    actionPrimary: { text: this.$t('actions.accept'), callback () { } },
                    icon: { color: 'error', name: 'mdi-close' },
                    color: 'primary',
                })
            }
        },
        formatDate(dateStr) {
            if (!dateStr) return '';
            
            try {
                const date = new Date(dateStr);
                return isNaN(date.getTime()) ? '' : date.toISOString().split('T')[0];
            } catch {
                return '';
            }
        },
        getFormattedDatePart(dateStr, format) {
            if (!dateStr) return '';
            
            try {
                const date = new Date(dateStr);
                if (isNaN(date.getTime())) return '';

                if (format === 'DD') {
                    return date.getDate().toString().padStart(2, '0');
                } else if (format === 'MM') {
                    return (date.getMonth() + 1).toString().padStart(2, '0');
                } else if (format === 'DD/MM') {
                    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}`;
                }
            } catch {
                return '';
            }
        }
    }
};
</script>

<style lang="sass" scoped>
.subject-item
    border-radius: 8px
    box-shadow: 0 2px 4px rgba(0,0,0,0.1)
    transition: all 0.3s ease

    &:hover
        box-shadow: 0 4px 8px rgba(0,0,0,0.15)

    .v-card-title
        padding: 16px !important
        border-bottom: 1px solid #d9d9d9

    .v-card-text
        padding: 16px !important

.period-item
    cursor: pointer
    padding: 12px
    border-radius: 4px
    transition: all 0.2s ease
    background: white

    &:hover
        background: #f5f5f5
        transform: translateY(-2px)
        box-shadow: 0 2px 4px rgba(0,0,0,0.1)

    &:active
        background: #e0e0e0
        transform: translateY(0)

.body-1
    font-size: 1rem !important
    font-weight: 400 !important
    line-height: 1.375 !important

.caption
    font-size: 0.875rem !important
    font-weight: 400 !important
    line-height: 1.375 !important
</style>
